var exports = {
  "wt": "detailsContainer__NcWQkI",
  "hQ": "contentContainer__1NEppW",
  "JY": "logsContainer__aKE39I",
  "KQ": "loadingText___mT6aA",
  "a6": "assistive__pCeoUG",
};

module.exports = exports;
